import { useState } from "react";

const MOODS = [
  { emoji: "😌", label: "Calm", color: "#A3B899" },
  { emoji: "😊", label: "Happy", color: "#F7D046" },
  { emoji: "😐", label: "Neutral", color: "#8A9A86" },
  { emoji: "😟", label: "Anxious", color: "#E6C54F" },
  { emoji: "😔", label: "Low", color: "#597B60" },
  { emoji: "😤", label: "Frustrated", color: "#e87c7c" },
  { emoji: "😴", label: "Exhausted", color: "#8A9A86" },
  { emoji: "🤔", label: "Uncertain", color: "#A3B899" },
];

const ENERGY_LEVELS = ["Very Low", "Low", "Moderate", "Good", "High"];

const MoodCheckin = () => {
  const [selectedMood, setSelectedMood] = useState(null);
  const [energy, setEnergy] = useState(null);
  const [note, setNote] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!selectedMood) return;
    setSubmitted(true);
  };

  if (submitted) {
    const mood = MOODS.find((m) => m.label === selectedMood);
    return (
      <div data-testid="mood-checkin" className="rounded-2xl p-8 text-center" style={{ background: "white", border: "1px solid var(--ll-border)" }}>
        <p className="text-5xl mb-4">{mood?.emoji}</p>
        <h2 className="font-serif text-2xl font-medium mb-2" style={{ color: "var(--ll-text)" }}>Check-In Recorded</h2>
        <p className="text-sm mb-2" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
          You're feeling <strong>{selectedMood}</strong>{energy !== null ? ` with ${ENERGY_LEVELS[energy].toLowerCase()} energy` : ""}.
        </p>
        <p className="text-sm mb-6" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
          {selectedMood === "Calm" || selectedMood === "Happy" ? "That's wonderful. Notice what contributed to this feeling and try to do more of it." :
            selectedMood === "Anxious" || selectedMood === "Frustrated" ? "It's okay to feel this way. Try the Breathing Anchor or Grounding exercise to help settle." :
            "Thank you for checking in with yourself. Awareness is the first step to wellbeing."}
        </p>
        <button onClick={() => { setSubmitted(false); setSelectedMood(null); setEnergy(null); setNote(""); }}
          className="rounded-full px-6 py-2.5 text-sm font-medium" style={{ background: "var(--ll-cta)", color: "var(--ll-cta-text)", fontFamily: "'Outfit', sans-serif" }}>
          Check In Again
        </button>
      </div>
    );
  }

  return (
    <div data-testid="mood-checkin" className="rounded-2xl p-8" style={{ background: "white", border: "1px solid var(--ll-border)" }}>
      <h2 className="font-serif text-2xl font-medium mb-2" style={{ color: "var(--ll-text)" }}>Mood Check-In</h2>
      <p className="text-sm mb-8" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
        Building self-awareness starts with noticing. How are you feeling right now? There's no wrong answer.
      </p>

      <p className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>How are you feeling?</p>
      <div className="grid grid-cols-4 gap-3 mb-8">
        {MOODS.map((m) => (
          <button key={m.label} data-testid={`mood-${m.label.toLowerCase()}`} onClick={() => setSelectedMood(m.label)}
            className="flex flex-col items-center gap-1.5 p-3 rounded-xl transition-all duration-300"
            style={{
              background: selectedMood === m.label ? `${m.color}20` : "var(--ll-bg-secondary)",
              border: `2px solid ${selectedMood === m.label ? m.color : "transparent"}`,
            }}>
            <span className="text-2xl">{m.emoji}</span>
            <span className="text-[10px] font-medium" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>{m.label}</span>
          </button>
        ))}
      </div>

      {selectedMood && (
        <>
          <p className="text-xs tracking-[0.2em] uppercase mb-3" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>Energy level</p>
          <div className="flex gap-2 mb-8">
            {ENERGY_LEVELS.map((level, i) => (
              <button key={level} onClick={() => setEnergy(i)}
                className="flex-1 py-2.5 rounded-xl text-xs font-medium transition-all"
                style={{
                  background: energy === i ? "var(--ll-cta)" : "var(--ll-bg-secondary)",
                  color: energy === i ? "var(--ll-cta-text)" : "var(--ll-text-muted)",
                  fontFamily: "'Outfit', sans-serif",
                }}>
                {level}
              </button>
            ))}
          </div>

          <button data-testid="mood-submit" onClick={handleSubmit}
            className="w-full rounded-full px-6 py-3.5 text-sm font-medium transition-all hover:-translate-y-0.5"
            style={{ background: "var(--ll-cta)", color: "var(--ll-cta-text)", fontFamily: "'Outfit', sans-serif" }}>
            Complete Check-In
          </button>
        </>
      )}
    </div>
  );
};

export default MoodCheckin;
